export default __webpack_public_path__ + "static/media/78.2d1a379e.png";